import ReactPlayer from 'react-player';
import React, { useRef } from 'react';


const PlayerElement = (props) => {
    const { url } = props;
    const playerRef = useRef(null);
    return (
        <div>
            <ReactPlayer ref={playerRef} url={url} controls={true} pip={true}/>
        </div>
    )
};

export default PlayerElement;